/* eslint-disable import/extensions */
import ContentOptions from './ContentOptions.jsx';
import AsButton from './ContentOptionsAsButton.jsx';
import AsIcon from './ContentOptionsAsIcon.jsx';

export const ContentOptionsAsButton = AsButton;
export const ContentOptionsAsIcon = AsIcon;
export default ContentOptions;
